export default {
  // 公开交易进度条
  processList: [
    '业务流程及准备材料',
    '编辑项目信息',
    '编辑受让资格',
    '上传附件信息',
    '重大事项提示',
    '承诺信息',
    '提交申请'
  ],
  // 协议交易进度条
  processListByTrade: [
    '编辑项目信息',
    '上传附件信息',
    '承诺信息',
    '提交申请'
  ],
  // 交易方式 1公开交易 2协议交易
  tradeType: '',

  // 转让方式 1整体交易 2拆分交易
  transferType: ''
};
